<template>
    <section id="contact" class="contact-area">
        <div class="container">
            <div class="row">

                <div class="col-12 col-sm-12 col-md-3 col-lg-5">
                    <div class="support-forum-img-box">
                        <img src="../../public/img/support-forum.svg" alt="support">
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-9 col-lg-7">
                    <!--contact-left-text-->
                    <div class="contact-form-wrapper">
                        <div class="section-title-area text-left"><h2 class="section-heading">Support Forum <span class="d-block"></span></h2></div>

                        <ContactForm/>

                    </div>
                    <!--contact-form-->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ContactForm from './Contact/Form'
export default {
    components: {
        ContactForm
    }
}
</script>